class Room {
  id?: string;

  name = '';

  capacity = 1;

  isReservableThroughFloorPlan = false;

  // Occupancy-gauge override: "feels empty below" / "feels overcrowded above". Not set means
  // inherit the level above. The API sends an unset threshold as JSON null rather than omitting
  // it, so both null and undefined occur at runtime — use isThresholdPairValid, never === undefined.
  thresholdMinPercentage?: number | null;

  thresholdMaxPercentage?: number | null;
}

export default Room;
